import React, { FunctionComponent } from 'react';
import styles from './Features.module.scss';
import { Block, FeaturesTile, BlockContent, BlockHeader } from 'components/elements';
import { WPAcfFeatures } from 'types/acf/features';

interface OwnProps {
  theme?: 'light' | 'grey' | 'dark' | 'green' | 'white';
  data: WPAcfFeatures | null;
}

type FeaturesProps = JSX.IntrinsicElements['div'] & OwnProps;

const Features: FunctionComponent<FeaturesProps> = props => {
  const { data, theme = 'light' } = props;

  if (!data || !data.items) {
    return null;
  }

  const { items = [], align = 'center', header } = data || {};

  return (
    <Block id="features" data-module="features" theme={theme}>
      <BlockContent>
        {header && <BlockHeader>{header}</BlockHeader>}
        <div className={styles.content}>{items && items?.map(item => <FeaturesTile data={item} align={align} key={item.title} />)}</div>
      </BlockContent>
    </Block>
  );
};

export default Features;
